import {
  Bell,
  Calculator,
  ClipboardList,
  Clock,
  FileText,
  GitCompare,
  ListOrdered,
  Mail,
  MapPin,
  MessageSquare,
  Package,
  PenLine,
  Phone,
  Search,
  Send,
  Tags,
  Truck,
  UserCheck,
  type LucideIcon,
} from "lucide-react";

/** Lucide names referenced from automation flow / product-canvas JSON. */
export type AutoFlowIconName =
  | "Bell"
  | "Calculator"
  | "ClipboardList"
  | "Clock"
  | "FileText"
  | "GitCompare"
  | "ListOrdered"
  | "Mail"
  | "MapPin"
  | "MessageSquare"
  | "Package"
  | "PenLine"
  | "Phone"
  | "Search"
  | "Send"
  | "Tags"
  | "Truck"
  | "UserCheck";

const AUTO_FLOW_ICONS: Record<AutoFlowIconName, LucideIcon> = {
  Bell,
  Calculator,
  ClipboardList,
  Clock,
  FileText,
  GitCompare,
  ListOrdered,
  Mail,
  MapPin,
  MessageSquare,
  Package,
  PenLine,
  Phone,
  Search,
  Send,
  Tags,
  Truck,
  UserCheck,
};

export function getAutoFlowIcon(name: AutoFlowIconName): LucideIcon {
  return AUTO_FLOW_ICONS[name];
}
